'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

const defaultErrorHandler = err => {
  // eslint-disable-next-line no-console
  console.error(err);
};
const ErrorBoundaryContext = /*#__PURE__*/react.createContext({
  handleError: defaultErrorHandler
});
const ErrorBoundaryProvider = (
// eslint-disable-next-line react/prop-types
{
  children,
  handleError = defaultErrorHandler
}) => {
  return /*#__PURE__*/react.createElement(ErrorBoundaryContext.Provider, {
    value: react.useMemo(() => ({
      handleError
    }), [handleError])
  }, children);
};

exports.ErrorBoundaryContext = ErrorBoundaryContext;
exports.ErrorBoundaryProvider = ErrorBoundaryProvider;
